import PropTypes from 'prop-types';
import React from 'react';

import { RECEIPT_NUMBER } from '../../../utils/constants';

const getVatIdentifiers = (type, vatIdentifiers) => vatIdentifiers?.find((item) => item.Type === type)?.Value;
const getFiscalDeviceID = (transaction) => transaction?.FiscalDocuments?.find((doc) => doc.FiscalDeviceID)?.FiscalDeviceID;

const SwedenAdditionalHeader = ({ invoiceNumber, retailTransaction, companyRegistrationNumber }) => {
  const taxItem = retailTransaction?.LineItems.find((item) => item.Tax);
  const vatIdentifiers = taxItem?.Tax?.VATIdentifiers;
  const officeVATId = getVatIdentifiers('OfficeVATId', vatIdentifiers);
  const storeVATId = getVatIdentifiers('StoreVATId', vatIdentifiers);
    const fiscalDeviceID = getFiscalDeviceID(retailTransaction);

  return (
    <div>
      {officeVATId && (<p>Office VAT ID: {officeVATId}</p>)}
      {storeVATId && (<p>Store VAT ID: {storeVATId}</p>)}
      {companyRegistrationNumber && (<p>Organization Number: {companyRegistrationNumber}</p>)}
      {fiscalDeviceID && (<p>Device ID: {fiscalDeviceID}</p>)}
      {(<p>Document Name: {RECEIPT_NUMBER}</p>)}
      {invoiceNumber && (<p>Document No: {invoiceNumber}</p>)}
      <br />
    </div>
  );
};

SwedenAdditionalHeader.propTypes = {
  companyRegistrationNumber: PropTypes.string,
  invoiceNumber: PropTypes.string,
  retailTransaction: PropTypes.shape().isRequired
};

SwedenAdditionalHeader.defaultProps = {
  companyRegistrationNumber: '',
  invoiceNumber: null
};

export default SwedenAdditionalHeader;
